// Falls back to the production API so data (cities, catalog, packages, etc.)
// also loads on preview deploys where REACT_APP_BACKEND_URL may be unset.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.japanunfolded.ai";
export const API = `${BACKEND_URL}/api`;

// Canonical host that serves the catalog place photos (highest-res source).
// japanunfolded.ai 307-redirects here, so we point straight at it to skip the
// hop and to keep images working on preview deploys (where /places/* isn't served).
export const IMG_HOST = "https://www.japanunfolded.ai";

// Resolve a catalog image value (e.g. "/places/senso-ji-temple.jpg" or a full
// URL) to an absolute URL on the canonical host.
export const placeImg = (path) => {
  if (!path) return "";
  if (/^https?:\/\//.test(path)) return path;
  return `${IMG_HOST}${path.startsWith("/") ? "" : "/"}${path}`;
};

// No AI pictures anywhere (owner, 2026-10-07): a place whose picture was generated by an AI in an older
// trip is shown like any place without a photo — the brand tile with the fan logo.
export const withoutIllustrations = (itinerary) => {
  if (!itinerary || !Array.isArray(itinerary.days)) return itinerary;
  const clean = (loc) => (loc && loc.image_source === "generated" ? { ...loc, image: null, image_source: null, image_credit: null } : loc);
  return { ...itinerary, days: itinerary.days.map(d => ({ ...d, time_blocks: (d.time_blocks || []).map(b => ({ ...b, locations: (b.locations || []).map(clean) })) })) };
};

export const CAT_CLASS = { culture:'culture', food:'food', nightlife:'nightlife', special:'special', popular:'popular', hidden_gem:'hidden_gem' };
export const CAT_LABEL = { culture:'CULTURE', food:'FOODIE', nightlife:'NIGHTLIFE', special:'SPECIAL', popular:'POPULAR', hidden_gem:'HIDDEN' };
